import axios from "axios";

import { apiBaseFrom } from "./api-base";
import { clerkEnabled, getClerkToken } from "./clerk";
import { normaliseErrorResponse } from "./api-errors";

// Unset resolves to `/api` — same origin — rather than the literal
// "undefined/api" this used to produce. See lib/api-base.js.
export const API_BASE = apiBaseFrom(process.env.REACT_APP_BACKEND_URL);

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Inject bearer token on each request (fallback if cookie is not set).
//
// Clerk first when it is configured: its session token is the live credential,
// and a stale `ac_token` left in localStorage from before the migration would
// otherwise win and authenticate as the wrong identity. Async because Clerk
// refreshes short-lived tokens on demand — axios awaits a promise here.
api.interceptors.request.use(async (cfg) => {
  cfg.headers = cfg.headers || {};
  if (clerkEnabled()) {
    const clerkToken = await getClerkToken();
    if (clerkToken) {
      cfg.headers.Authorization = `Bearer ${clerkToken}`;
      return cfg;
    }
    // No Clerk session: fall through rather than sending nothing, so a PAT
    // held by the extension still works during the transition.
  }
  const token = localStorage.getItem("ac_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// A 422 from FastAPI carries a list of validation objects in `detail`; every
// page renders `detail` as text. Made safe here so no page has to know.
api.interceptors.response.use((res) => res, normaliseErrorResponse);
